import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-progress-bar-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-progress-bar-status", style: {
    width: "".concat(this.helpers.getPercentStatus(), "%")
  } }));
}
